<template>
    <div name="hospital" class="hospital">
        <div class="inner-div">
            <div class="cont cont-wrap01">
                <span class="h-title">새로워진 <span class="text-impact">솔닥</span><br>이렇게 이용하세요</span>
                <span class="h-sub-title">달라진 비대면 진료 이용 정책에 따른<br><strong class="text-semi">새로워진 솔닥 이용 방법</strong>을 안내해드려요.</span>
                <img class="bg-img" src="../../assets/renew_mobile/bg_mobile.png" />
            </div>

            <div class="cont cont-wrap02">
                <span class="h-title"><span class="text-impact">솔닥,</span> 언제 이용하나요?</span>

                <div class="box-wrap">
                    <div class="box">
                        <div class="box-body">
                            <div class="box-tit">
                                <span class="num">1</span>
                                <p class="text">솔닥 제휴 병원에서 <strong class="text-semi">대면 진료를 완료한 후,</strong> <span class="nuder-line">30일 이내에 재진</span>이 필요한 경우 솔닥을 통해 비대면 진료를 받을 수
                                    있어요.</p>
                            </div>
                            <div class="cont-detail">
                                <span class="check-label">check</span>
                                <p>만성질환의 경우 대면 진료를 완료한 후<br> 1년 동안 비대면 진료가 가능해요.</p>
                                <dl class="text-explan">
                                    <dt>비대면 진료 가능 만성질환</dt>
                                    <dd>고혈압, 당뇨병, 정신 및 행동장애, 호흡기결핵, 심장질환, 대뇌혈관질환, 신경계질환, 악성신생물, 갑상선의장애, 간의질환, 만성신부전증</dd>
                                </dl>
                                <dl class="text-explan">
                                    <dt>그 외</dt>
                                    <dd>소아 환자(만 18세 미만)의 경우 대면진료 이후 비대면 진료(재진) 원칙, 휴일&#183;야간에 한해 대면 진료 기록이 없더라도 비대면 진료를 통한 의학적 상담은 가능(처방 불가)</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-body">
                            <div class="box-tit">
                                <span class="num">2</span>
                                <p class="text">대면 진료 없이 비대면 진료가 가능한 경우,<br> 해당사항을 확인해보세요.</p>
                            </div>
                            <div class="cont-detail">
                                <span class="check-label">check</span>
                                <p>거동불편자, 65세 이상 장기요양대상자 등<br> 대면 진료 없이 비대면 진료가 가능해요.</p>
                                <dl class="text-explan">
                                    <dt>초진 비대면 진료 가능한 경우</dt>
                                    <dd>섬&#183;벽지 환자(의료기관 부족 지역(섬: 363개, 벽지: 116개 등) 거주자), 거동불편자, 65세 이상 노인(장기요양 대상자), 등록 장애인, 감염병 확진 환자(제1급 또는 제2급 감염병 확진자로 다른 의료기관 진료 필요 시)</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cont cont-wrap03">
                <span class="h-title"><span class="text-impact">솔닥,</span> 어떻게 이용하나요?</span>

                <div class="box-wrap pb-0">
                    <div class="box">
                        <div class="box-img"><img src="../../assets/renew_mobile/img_howto01.jpg" /></div>
                        <div class="box-body">
                            <div class="box-tit">
                                <span class="num">1</span>
                                <div class="text">
                                    <strong class="tit text-semi">방문하신 병원에서 솔닥 QR코드를 찾아주세요</strong>
                                    <p>솔닥 제휴 병원에 방문하셨다면, 원내에 비치된 솔닥 QR코드를 찾아주세요.</p>
                                </div>
                            </div>
                            <div class="box-tit">
                                <span class="num">2</span>
                                <div class="text">
                                    <strong  class="tit text-semi">솔닥 카카오 채널에서 QR 코드를 스캔하세요</strong>
                                    <p>카카오톡 솔닥 채널 채팅창 메뉴의 <strong class="text-semi">QR병원등록</strong>을 선택 후 병원 내 QR 코드를 스캔하세요</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-img mb-2"><img src="../../assets/renew_mobile/img_howto02.jpg" /></div>
                        <div class="box-body">
                            <div class="box-tit">
                                <span class="num">3</span>
                                <div class="text">
                                    <strong  class="tit text-semi">간단한 정보 입력 후 병원 등록을 완료하세요</strong> 
                                    <p>등록 정보를 입력하면 병원 등록이 완료됩니다.<br>이제 솔닥을 통해 비대면 진료가 가능해요.</p>
                                </div>
                            </div>
                            <div class="box-tit mb-0">
                                <span class="num">4</span>
                                <div class="text">
                                    <strong  class="tit text-semi">다음 번 진료 시 필요한 진료를 예약하세요</strong>
                                    <p>카카오톡 솔닥 채널 채팅창 메뉴의 예약하기를 선택 후 비대면 진료를 예약하세요.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cont cont-wrap04">
                <span class="h-title"><span class="text-impact">처방약 수령</span> 방법은?</span>

                <div class="box-wrap pb-4">
                    <div class="box">
                        <div class="box-img"><img src="../../assets/renew_mobile/img_howto03.jpg" /></div>
                        <div class="box-body">
                            <div class="box-tit">
                                <span class="num">1</span>
                                <div class="text">
                                    <strong class="tit text-semi">비대면으로 처방 받은 약은 약국에서 수령하세요</strong>
                                    <p>솔닥을 통해 간편하게 약국을 선택하여 처방전을 전송하고 직접 수령할 수 있어요.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-img"><img src="../../assets/renew_mobile/img_howto04.jpg" /></div>
                        <div class="box-body">
                            <div class="box-tit mb-2">
                                <span class="num">2</span>
                                <div class="text">
                                    <strong  class="tit text-semi">병원 판매 의료기기의 경우 택배로 수령하세요</strong> 
                                    <p>병원에서 받을 수 있는 의료기기(MD)의 경우 간편하게 집으로 배송해 드립니다.</p>
                                </div>
                            </div>

                            <div class="cont-detail cont-md">
                                <span class="check-label">check</span>
                                <p>당일 배송 가능 지역을 확인하세요 <br>(그 외 지역 일반 택배 배송)</p>
                                <div class="text-explan">
                                    <p>
                                        서울 전 지역, 성남 전 지역, 부천 전 지역, 안양
                                        전 지역, 과천 전 지역
                                    </p>
                                    <dl>
                                        <dt>고양 : </dt>
                                        <dd>일산 서구 / 일산 동구 / 덕양구 화정동, 행신동</dd>
                                    </dl>
                                    <dl>
                                        <dt>인천 : </dt>
                                        <dd>부평구 / 계양구 / 미추홀구 / 남동구 간석동, 만수동, 구월동</dd>
                                    </dl>
                                    <dl>
                                        <dt>하남 : </dt>
                                        <dd>선동, 망월동, 감일동, 감이동, 학암동</dd>
                                    </dl>
                                    <dl>
                                        <dt>광명 : </dt>
                                        <dd>광명 1~5동, 철산 1~4동, 하안 2~4동, 소하 1~2동, 일직동</dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

      
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'hospital',
    mounted: function()
    {
        let eheight = $('.introduction').outerHeight();
        $(window).scroll(function () {
            var height = $(document).scrollTop();
            // console.log(height);
            let winHeight = $(window).height();
            if(height > eheight * 0.5 && height < eheight * 0.8)
            {
                $('.cont-wrap01 .h-title').css('display', `block`);
                $('.cont-wrap01 .h-sub-title').css('display', `block`);
                $('.cont-wrap01 .bg-img').css('display', `inline-block`);
            }
            else if(height >= eheight* 0.8)
            {
                $('.cont-wrap01 .h-title').css('display', `block`);
                $('.cont-wrap01 .h-sub-title').css('display', `block`);
                $('.cont-wrap01 .bg-img').css('display', `inline-block`);
            }
            
            if(height > eheight * 0.9 && height < eheight * 1.0)
            {
                $('.cont-wrap02 .h-title').css('display', `block`);
                $('.cont-wrap02 .box-wrap').css('display', `flex`);
            }
            else if(height >= eheight* 1.0)
            {
                $('.cont-wrap02 .h-title').css('display', `block`);
                $('.cont-wrap02 .box-wrap').css('display', `flex`);
            }

            if(height > eheight * 2.0 && height < eheight * 2.1)
            {
                $('.cont-wrap03 .h-title').css('display', `block`);
                $('.cont-wrap03 .box-wrap').css('display', `flex`);
            }
            else if(height >= eheight* 2.1)
            {
                $('.cont-wrap03 .h-title').css('display', `block`);
                $('.cont-wrap03 .box-wrap').css('display', `flex`);
            }

            if(height > eheight * 4.3 && height < eheight * 4.4)
            {
                $('.cont-wrap04 .h-title').css('display', `block`);
                $('.cont-wrap04 .box-wrap').css('display', `flex`);
            }
            else if(height >= eheight*  4.4)
            {
                $('.cont-wrap04 .h-title').css('display', `block`);
                $('.cont-wrap04 .box-wrap').css('display', `flex`);
            }
        });
    },
    methods: {} 
    }
</script>

<style scoped>
    @media screen and (max-width: 360px){
        .hospital{
            width: 100%;
            min-height: 484px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            padding-top: 59px;
            z-index: 4;
            position: relative;
            overflow: hidden;
            background: #F5F8FF;
        }

        .h-title {
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 600;
            font-size: 23px;
            line-height: 30px;
            /* or 138% */

            text-align: center;

            color: #1A1A1A;
            animation: fadeInUp 1s;
            display: none;
            justify-content: center;
        }
        .text-impact{
            color: #004EDD;
        }
        .h-sub-title{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            /* or 156% */
            text-align: center;
            justify-content: center;
            color: #1A1A1A;
            margin-top: 18px;
            animation: fadeInUp2 1s;
            display: none;
        }
        .hospital-video {
            animation: fadeInUp2 1s;
            z-index: 1;
            display: none;
            margin-top: 50px;
            width: 100%;
            height: auto;
            margin-bottom: 70px;
        }
    }
    @media screen and (min-width: 361px){
        .hospital{
            width: 100%;
            min-height: 720px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            padding-top: 87px;
            z-index: 4;
            position: relative;
            overflow: hidden;
            background: #F5F8FF;
        }
    }
    
    .inner-div{
        width: 100%;  
        margin-bottom: 65px;
    }
    .cont{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        margin: 0 auto;
    }
    .cont-wrap01{
        position: relative;
        height: 512px;
        /* margin-top: 30px */
    }
    .cont-wrap02{
        height: 972px;
        margin: 113px 0 36px;
    }
    .cont-wrap03{
        min-height: 1025px;
        margin: 85px 0 36px;
    }
    .cont-wrap04{
        margin: 76px 0 36px;
    }
    .h-title {
        font-family: 'Pretendard';
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 44px;
        /* or 138% */

        text-align: center;
        color: #1A1A1A;
        animation: fadeInUp 1s;
        display: none;
        justify-content: center;
    }
    .text-impact{
        color: #004EDD;
    }
    .h-sub-title{
        font-family: 'Pretendard';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
        /* or 156% */
        text-align: center;
        justify-content: center;
        color: #1A1A1A;
        margin-top: 18px;
        animation: fadeInUp2 1s;
        display: none;
    }

    .bg-img {
        position: absolute;
        top: -87px;
        display: flex;
        width: 722px;
        height: 665px;
        display: none;
        animation: fadeInUp 1s;
    }

    .box-wrap{
        display: flex;
        flex-direction: column;
        width: calc(100% - 40px);
        margin: 30px 20px 0;
        padding-bottom: 30px;
        display: none;
        animation: fadeInUp 1s;
        border-radius: 10px;
        background: #fff;
        overflow: hidden;
    }
    .box{
        flex: 0 0 auto;
        width: 100%;
        /* margin: 20px; */
        /* border-radius: 10px;
        background: #fff; */
        overflow: hidden;
    }
    .box-body{
        padding: 30px 30px 17px 15px;
    }
    .box-img{
        display: block;
        position: relative;
        width: 100%;
        /* height: 0; */
        height: 217px;
        padding-top: 58%;
    }
    .box-img img{
        position: absolute;
        top:0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .box-img+.box-body{
        padding: 15px 22px 25px 15px;
    }
    .box-img+.box-body .box-tit{
        margin-bottom: 17px;
    }

    .box-tit{
        display: flex;
        flex-direction: row;
        /* min-height: 105px; */
        height: auto;
        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 400;
        color: #1A1A1A;
        word-break: keep-all;
    }
    .num{
        display: inline-block;
        width: 30px;
        flex: 0 0 auto;
        font-size: 24px;
        font-weight: 600;
        color: #004EDD;
        text-align: center;
    }
    .box-tit .text{
        margin-left: 10px;
        line-height: 1.6;
        word-break: break-all;
    }
    .box-tit .tit{
        display: block;
        margin-bottom: 4px;
    }
    .nuder-line{
        text-decoration: underline;
        text-underline-offset: 3px;
    }

    .cont-detail{
        position: relative;
        width: calc(100% - 42px);
        height: auto;
        margin-left: 42px;
        padding: 19px 13px 15px;
        background: #ECEFF8;
    }
    .cont-detail.cont-md{
        width: calc(100% - 50px);
        padding: 19px 20px 10px 13px;
    }
    .cont-md p{
        margin-bottom: 2px;
    }
    .cont-md .text-explan dl{
        display: flex;
        margin-bottom: 1px;
    }
    .cont-md .text-explan dt{
        flex: 0 0 auto;
        margin-right: 3px;
    }

    .cont-detail::before{
        position: absolute;
        top: -0.5px;
        left: 0;
        display: block;
        width: 100%;
        height: 1px;
        background: #004EDD;
        content: '';
    }
    .cont-detail::after{
        position: absolute;
        bottom: -0.5px;
        left: 0;
        display: block;
        width: 100%;
        height: 1px;
        background: #004EDD;
        content: '';
    }
    .check-label{
        position: relative;
        display: inline-block;
        width: 58px;
        height: 18px;
        padding-left: 17px;
        background: #004EDD;
        font-size: 12px;
        line-height: 1.6;
        color: #fff;
    }
    .check-label::before{
        position: absolute;
        top: 2px;
        left: 3px;
        width: 14px;
        height: 14px;
        background: url(../../assets/renew_mobile/ico_check.png);
        background-size: 14px auto;
        background-position: center center;
        content: '';
    }
    .check-label+p{
        margin: 8px 0 6px;
        font-size: 16px;
        font-weight: 400;
        color: #1A1A1A;
    }
    .text-explan{
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #666;
    }
    .text-explan dt{
        margin-bottom: 1px;
        font-weight: 600;
    }
    .text-explan dd{
        margin-bottom: 0;
        line-height: 1.55;
    }

    .box-detail{
        width: 100%;
        height: 138px;
        margin-top: 6px;
        padding: 23px 20px 30px 30px;
        border-radius: 10px;
        background: #ECEFF8;
        /* display: none; */
        animation: fadeInUp 1.5s;
    }
    .detail-tit{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .detail-tit strong{
        margin-left: 13px;
        font-size: 20px;
        font-weight: 600;
        color: #1A1A1A;
    }
    .detail-text{
        margin-top: 14px;
        color: #666;
    }

    .text-semi{
        font-weight: 600;
    }
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    @keyframes fadeInUp2 {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    @keyframes fadeInUp3 {
        0% {
            opacity: 0;
            left: 50%;
            transform: translate(100%);
        }
        to {
            opacity: 1;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_main/Hospital.vue